export default {
  phoneCall: {
    is: 'Þú átt von á símtali frá sérfræðingi okkar',
    en: 'You can expect a call from our advisor.',
  },
  consultationAppointment: {
    is: 'Þú átt pantaðan tíma með sérfræðingi okkar.',
    en: 'You have made a consultation appointment with one of our advisors.',
  },
  branch: {
    is: 'Staðsetning',
    en: 'Branch',
  },
  type: {
    is: 'Þjónusta',
    en: 'Type of service',
  },
  date: {
    is: 'Dagsetning',
    en: 'Date',
  },
  time: {
    is: 'Klukkan',
    en: 'Time',
  },
  close: {
    is: 'Loka',
    en: 'Close',
  },
  successTitle: {
    is: 'Kærar þakkir',
    en: 'Thank you',
  },
};
